import React, { useEffect, useState } from 'react';
import { Badge, Btn, Card, NoData, Search, Select, toast } from '../ui.jsx';

function TeacherAttendance({ db, save }) {
  const [attCls, setAttCls] = useState('');
  const [attDt, setAttDt] = useState(new Date().toISOString().split('T')[0]);
  const [attMap, setAttMap] = useState({});
  const [repCls, setRepCls] = useState('');
  const [subTab, setSubTab] = useState(0);
  const classes = db.classes.map(c => c.name);
  const attStu = db.students.filter(s => s.cls === attCls);

  useEffect(() => {
    const saved = db.att[attDt] || {};
    const m = {};
    attStu.forEach(s => { m[s.id] = saved[s.id] || 'P'; });
    setAttMap(m);
  }, [attCls, attDt]); // eslint-disable-line

  const saveAtt = () => {
    if (!attCls || !attDt) { toast('Select class and date', 'err'); return; }
    save({ ...db, att: { ...db.att, [attDt]: { ...db.att[attDt], ...attMap } } });
    toast('Attendance saved');
  };

  const p = Object.values(attMap).filter(v => v === 'P').length;
  const a = Object.values(attMap).filter(v => v === 'A').length;
  const l = Object.values(attMap).filter(v => v === 'L').length;

  const pageHeader = (title, sub) => (
    <div style={{ marginBottom: 24 }}>
      <h1 style={{ fontSize: 26, fontWeight: 800, color: '#1e293b', fontFamily: 'Manrope,sans-serif', margin: 0 }}>{title}</h1>
      {sub && <p style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{sub}</p>}
    </div>
  );

  return (
    <div className="teacher-attendance-page">
      {pageHeader('Attendance', 'Mark and review student attendance')}
      <div className="teacher-subtab-bar" style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f1f5f9', borderRadius: 10, padding: 4, width: 'fit-content' }}>
        {['Mark Attendance', 'Attendance Report'].map((t, i) => (
          <button key={t} onClick={() => setSubTab(i)} style={{ padding: '7px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Manrope,sans-serif', background: subTab === i ? '#fff' : 'transparent', color: subTab === i ? '#1960a3' : '#64748b', boxShadow: subTab === i ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', transition: 'all 150ms' }}>{t}</button>
        ))}
      </div>

      {subTab === 0 && (
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #e8edf5', boxShadow: '0 2px 12px rgba(0,32,69,0.06)', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <select value={attCls} onChange={e => setAttCls(e.target.value)} style={{ padding: '7px 12px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 12, fontFamily: 'inherit', color: '#1e293b', background: '#fff', cursor: 'pointer' }}>
              <option value="">Select Class</option>{classes.map(c => <option key={c}>{c}</option>)}
            </select>
            <input type="date" value={attDt} onChange={e => setAttDt(e.target.value)} style={{ padding: '7px 12px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 12, fontFamily: 'inherit', color: '#1e293b' }} />
            {attCls && <div style={{ display: 'flex', gap: 8, marginLeft: 'auto', alignItems: 'center' }}>
              <span style={{ fontSize: 11, color: '#64748b' }}>P:<b style={{ color: '#059669' }}>{p}</b> A:<b style={{ color: '#ef4444' }}>{a}</b> L:<b style={{ color: '#0891b2' }}>{l}</b></span>
              <button onClick={() => { const m = {}; attStu.forEach(s => { m[s.id] = 'P'; }); setAttMap(m); }} style={{ padding: '6px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', background: '#fff', fontSize: 11, fontWeight: 700, cursor: 'pointer', color: '#475569' }}>All Present</button>
              <button onClick={saveAtt} style={{ padding: '6px 16px', borderRadius: 8, border: 'none', background: '#059669', color: '#fff', fontSize: 11, fontWeight: 700, cursor: 'pointer', boxShadow: '0 2px 8px rgba(5,150,105,0.3)' }}>Save</button>
            </div>}
          </div>
          {!attCls ? (
            <div style={{ padding: '48px', textAlign: 'center', color: '#94a3b8' }}>
              <span className="material-symbols-outlined" style={{ fontSize: 40, display: 'block', marginBottom: 8 }}>fact_check</span>
              <div style={{ fontSize: 13 }}>Select a class to mark attendance</div>
            </div>
          ) : !attStu.length ? (
            <div style={{ padding: '48px', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>No students in this class</div>
          ) : (
            <div className="teacher-table-wrap" style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  <th style={{ padding: '10px 20px', textAlign: 'left', fontSize: 10, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', background: '#f8fafc' }}>Roll</th>
                  <th style={{ padding: '10px 20px', textAlign: 'left', fontSize: 10, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', background: '#f8fafc' }}>Student</th>
                  {['Present', 'Absent', 'Leave'].map(h => <th key={h} style={{ padding: '10px 16px', textAlign: 'center', fontSize: 10, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', background: '#f8fafc' }}>{h}</th>)}
                </tr></thead>
                <tbody>{attStu.map((s, i) => (
                  <tr key={s.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#64748b' }}>{s.roll}</td>
                    <td style={{ padding: '12px 20px', fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{s.fn} {s.ln}</td>
                    {['P', 'A', 'L'].map(v => (
                      <td key={v} style={{ padding: '12px 16px', textAlign: 'center' }}>
                        <input type="radio" name={'att-' + s.id} value={v} checked={attMap[s.id] === v} onChange={() => setAttMap(m => ({ ...m, [s.id]: v }))}
                          style={{ width: 16, height: 16, accentColor: v === 'P' ? '#059669' : v === 'A' ? '#ef4444' : '#0891b2', cursor: 'pointer' }} />
                      </td>
                    ))}
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {subTab === 1 && (
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #e8edf5', boxShadow: '0 2px 12px rgba(0,32,69,0.06)', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
            <select value={repCls} onChange={e => setRepCls(e.target.value)} style={{ padding: '7px 12px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 12, fontFamily: 'inherit', color: '#1e293b', background: '#fff', cursor: 'pointer' }}>
              <option value="">Select Class</option>{classes.map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          {!repCls ? (
            <div style={{ padding: '48px', textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>Select a class to view report</div>
          ) : (
            <div className="teacher-table-wrap" style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  {['Student', 'Present', 'Absent', 'Leave', 'Total', '%'].map(h => <th key={h} style={{ padding: '10px 20px', textAlign: 'left', fontSize: 10, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', background: '#f8fafc' }}>{h}</th>)}
                </tr></thead>
                <tbody>{db.students.filter(s => s.cls === repCls).map((s, i) => {
                  let sp = 0, sa = 0, sl = 0;
                  Object.values(db.att).forEach(d => { const v = d[s.id]; if (v === 'P') sp++; else if (v === 'A') sa++; else if (v === 'L') sl++; });
                  const tot = sp + sa + sl; const pct = (sp + sa) > 0 ? Math.round(sp / (sp + sa) * 100) : 0;
                  return <tr key={s.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                    <td style={{ padding: '12px 20px', fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{s.fn} {s.ln}</td>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#059669', fontWeight: 700 }}>{sp}</td>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#ef4444', fontWeight: 700 }}>{sa}</td>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#0891b2', fontWeight: 700 }}>{sl}</td>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#64748b' }}>{tot}</td>
                    <td style={{ padding: '12px 20px' }}>
                      <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: pct >= 90 ? '#d1fae5' : pct >= 75 ? '#fef3c7' : '#fee2e2', color: pct >= 90 ? '#059669' : pct >= 75 ? '#d97706' : '#ef4444' }}>{pct}%</span>
                    </td>
                  </tr>;
                })}</tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}


export default TeacherAttendance;
